"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const snowplow_js_common_1 = require("@angi/snowplow-js-common");
const index_1 = require("../../index");
/**
 * Defines a useEffect that will instantiate a new snowplow tracker
 */
function useSnowplowTracker(params) {
    const [isReady, setIsReady] = (0, react_1.useState)(false);
    const snowplow = (0, index_1.useSnowplowListener)();
    (0, react_1.useEffect)(() => {
        (0, snowplow_js_common_1.snowplowTracker)(params);
        if (snowplow !== undefined) {
            setIsReady(true);
        }
        return () => {
            (0, snowplow_js_common_1.clearGlobalContexts)();
        };
    }, [params.appId, snowplow]);
    return isReady;
}
exports.default = useSnowplowTracker;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlU25vd3Bsb3dUcmFja2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3JlYWN0L2hvb2tzL3VzZVNub3dwbG93VHJhY2tlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGlDQUE0QztBQUM1QyxpRUFBZ0Y7QUFFaEYsdUNBQWtEO0FBRWxEOztHQUVHO0FBQ0gsU0FBUyxrQkFBa0IsQ0FBQyxNQUE2QjtJQUNyRCxNQUFNLENBQUMsT0FBTyxFQUFFLFVBQVUsQ0FBQyxHQUFHLElBQUEsZ0JBQVEsRUFBQyxLQUFLLENBQUMsQ0FBQztJQUU5QyxNQUFNLFFBQVEsR0FBRyxJQUFBLDJCQUFtQixHQUFFLENBQUM7SUFFdkMsSUFBQSxpQkFBUyxFQUFDLEdBQUcsRUFBRTtRQUNYLElBQUEsb0NBQWUsRUFBQyxNQUFNLENBQUMsQ0FBQztRQUN4QixJQUFJLFFBQVEsS0FBSyxTQUFTLEVBQUU7WUFDeEIsVUFBVSxDQUFDLElBQUksQ0FBQyxDQUFDO1NBQ3BCO1FBRUQsT0FBTyxHQUFHLEVBQUU7WUFDUixJQUFBLHdDQUFtQixHQUFFLENBQUM7UUFDMUIsQ0FBQyxDQUFDO0lBQ04sQ0FBQyxFQUFFLENBQUMsTUFBTSxDQUFDLEtBQUssRUFBRSxRQUFRLENBQUMsQ0FBQyxDQUFDO0lBRTdCLE9BQU8sT0FBTyxDQUFDO0FBQ25CLENBQUM7QUFFRCxrQkFBZSxrQkFBa0IsQ0FBQyJ9


// WEBPACK FOOTER //
// ../../../../src/react/hooks/useSnowplowTracker.ts